// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__SzWJl","main":"index_main__j0fgd"};